import instance from "..";
import { IResponseInit } from "./types/response";

const AccountDetailsAPI = {
  init: () => instance.get<IResponseInit>("app/init-accounts-details"),
};

export default AccountDetailsAPI;
